export const getABBucket = (testName = "tefl_abtest_bucket") => {
  if (typeof window === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(^| )${testName}=([^;]+)`));
  const result = match ? match[2] : null;
  console.log("getABBucket:", result, typeof result);
  return result;
};